import { AbstractSet } from './AbstractSet';
import { IdBufferListener } from '../id/IdBufferListener';
import { SetIfc } from '../SetIfc';
import { SequentialDummySetListener } from '../SequentialDummySetListener';
import { BitBoardEntity } from '../../utils/BitBoardEntity';

export class BufListener extends SequentialDummySetListener{
    buffer:IdBufferListener;
    bufferOperator:IdBufferOperator;
    
    constructor( buffer:IdBufferListener, bufferOperator:IdBufferOperator ) 
    {
        super();
        this.buffer = buffer;
        this.bufferOperator = bufferOperator;
    }
    
    public addRecord( id:number ):void {
        super.addRecord( id );
        this.bufferOperator.put(id);
        this.buffer.addRecord(id);
    }

    public deleteRecord( id:number ):void {
        super.deleteRecord(id);
        this.bufferOperator.removeRecord(id);
        this.buffer.deleteRecord(id);
    }
    
    public reset():void {
        super.reset();
        this.bufferOperator.reset();
        this.buffer.reset();
    }

    public cellsUpdated( colls:BitBoardEntity, id:number ):void {
        super.cellsUpdated(colls, id);
        this.buffer.cellsUpdated(colls, id);
    }
    
    public begin():void {
        super.begin();
        this.buffer.begin();
    }
    
    public end():void {
        super.end();
        this.buffer.end();
    }	
    public setContainerMetaData( name:string, value:string ):void {
        super.setContainerMetaData( name, value );
        this.buffer.setContainerMetaData( name, value );
    }
    public setContainerMetaDatas( names:Array<string>, values:Array<string>):void {
        super.setContainerMetaDatas( names, values );
        this.buffer.setContainerMetaDatas( names, values );
    }
    publicremoveContainerMetaDatas( names:Array<string> ):void {
        super.removeContainerMetaDatas( names );
        this.buffer.removeContainerMetaDatas( names );
    }
    public removeMetaData( name:string ):void {
        super.removeMetaData( name );
        this.buffer.removeMetaData( name );
    }
}

export class IdBufferOperator extends AbstractSet{
    under:SetIfc;
    buffer:IdBufferListener;
    lis:BufListener;
    
    constructor( under:SetIfc ) 
    {
        super( under.getShape() );
        this.under = under;
        
        this.buffer = new IdBufferListener( under.getShape(), under.getShape(), this.dispatcher );
        
        this.lis = new BufListener( this.buffer, this );
        
        under.addListener( this.lis );
    }
    
    public destructImpl():void {
        this.under.removeListener( this.lis );	
    }
}